module.exports = __webpack_public_path__ + "img/run5.13e56339.png";